import { render, staticRenderFns } from "./impresionData2.vue?vue&type=template&id=d4d713fc"
import script from "./impresionData2.vue?vue&type=script&lang=js"
export * from "./impresionData2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports